/**Import react select */
import React from
	'react'
import propTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import Select from 'react-select'
import Slide from '@material-ui/core/Slide'

import LateralPanel from '../../common/lateralPanel/LateralPanel'
import { panelLateralServicesStyles } from '../../../resources/styles/PanelLateralServicesStyles'

/** Material UI import section */
import { Fab, Typography } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Clear'
import BarChartIcon from '@material-ui/icons/BarChart'
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep'

/**
 * Spare part lateral panels
 * @param {*} props
 */
const FilterChartPanel = (props) => {
	const classes = panelLateralServicesStyles()
	const { handleSubmit } = useForm()

	return (
		<Slide direction="left" in={props.open} mountOnEnter unmountOnExit timeout={500}>
			<div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
				<LateralPanel open={props.open} onClose={props.onClose} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
					<form style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
						<PanelHeader
							onClose={props.onClose}
							isSaving={props.isSaving}
							title={'Filter Charts'}
							handleSubmit={handleSubmit}
						/>
						<div
							className={classes.panelContent}
							style={{
								flex: 1,
								overflowY: 'auto',
								height: '100%',
								minHeight: 'calc(100vh - 140px)',
								maxHeight: 'calc(100vh - 140px)',
							}}
						>
							{/* Serial number year section using FilterBlock */}
							<FilterBlock
								title='Serial number year'
								options={props.years}
								field="year"
								onFilterOptionClick={props.onFilterOptionClick}
								selectedValues={props.selectedYears}
								onRemoveFilterOption={props.onRemoveFilterOption}
							/>

							{/* Model section */}
							<FilterBlock
								title='Model'
								options={props.models}
								field="model"
								onFilterOptionClick={props.onFilterOptionClick}
								selectedValues={props.selectedModels}
								onRemoveFilterOption={props.onRemoveFilterOption}
							/>

							{/* GAE section */}
							<FilterBlock
								title='GAE'
								options={props.gae}
								field="gae"
								onFilterOptionClick={props.onFilterOptionClick}
								selectedValues={props.selectedGae}
								onRemoveFilterOption={props.onRemoveFilterOption}
							/>

							{/* NomSol section */}
							<FilterBlock
								title='Applicant'
								options={props.nomSol}
								field="nomSol"
								onFilterOptionClick={props.onFilterOptionClick}
								selectedValues={props.selectedNomSol}
								onRemoveFilterOption={props.onRemoveFilterOption}
							/>

							{/* MaterialPt section */}
							<FilterBlock
								title='Material Pt'
								options={props.materialPt}
								field="materialPt"
								onFilterOptionClick={props.onFilterOptionClick}
								selectedValues={props.selectedMaterialPt}
								onRemoveFilterOption={props.onRemoveFilterOption}
							/>

							{/* Fault section */}
							<FilterBlock
								title='Fault'
								options={props.faults}
								field="fault"
								onFilterOptionClick={props.onFilterOptionClick}
								selectedValues={props.selectedFaults}
								onRemoveFilterOption={props.onRemoveFilterOption}
							/>

							{/* Failure section */}
							<FilterBlock
								title='Failure'
								options={props.failures}
								field="failure"
								onFilterOptionClick={props.onFilterOptionClick}
								selectedValues={props.selectedFailures}
								onRemoveFilterOption={props.onRemoveFilterOption}
							/>
						</div>
						{/* Spacer to push the button to the bottom */}
						<div style={{ flexShrink: 0 }}>
							<div style={{
								padding: 24,
								display: 'flex',
								justifyContent: 'center',
								position: 'sticky',
								bottom: 0,
								background: '#fff'
							}}>
								<button
									type="button"
									onClick={props.onDeleteAllFilter}
									style={{
										background: classes.faultWarrantyIconSelected?.backgroundColor || '#5357DC',
										color: '#fff',
										border: 'none',
										borderRadius: 8,
										padding: '10px 32px',
										fontWeight: 600,
										fontSize: 16,
										cursor: 'pointer',
										boxShadow: '0 2px 8px rgba(58,134,255,0.08)',
										display: 'flex',
										alignItems: 'center',
										gap: 8
									}}
								>
									<DeleteSweepIcon style={{ color: '#fff', marginRight: 8 }} />
									Clear Filters
								</button>
							</div>
						</div>
					</form>
				</LateralPanel>
			</div>
		</Slide>
	)
}
FilterChartPanel.propTypes = {
	open: propTypes.bool.isRequired,
	onSaveSparePart: propTypes.func,
	isSaving: propTypes.bool,
	onClose: propTypes.func,
	onDeleteAllFilter: propTypes.func,
	years: propTypes.array,
	models: propTypes.array,
	materialPt: propTypes.array,
	selectedMaterialPt: propTypes.array,
}
FilterChartPanel.defaultPanel = {
	open: false,
	isSaving: false,
	onSaveSparePart: () => console.warn('No [onSaveSparePart] callback defined')
}
export default FilterChartPanel

const FilterBlock = ({
	title,
	options,
	field,
	onFilterOptionClick,
	selectedValues = [],
	onRemoveFilterOption
}) => (
	<div style={{ marginTop: 25 }}>
		<Typography variant='subtitle2' style={{ fontWeight: 600 }}>
			{title}
		</Typography>

		<Select
			placeholder='Select an option'
			options={options}
			isSearchable
			value={null}
			onChange={option => {
				if (option && !selectedValues.includes(option.value)) {
					onFilterOptionClick && onFilterOptionClick(field, option.value)
				}
			}}
			styles={{ container: (b) => ({ ...b, marginTop: 8 }) }}
		/>

		{/* Show cards for selected options */}
		<div
			style={{
				display: 'flex',
				flexWrap: 'wrap',
				gap: 8,
				marginTop: 12
			}}
		>
			{selectedValues.map((val, i) => {
				const opt = options.find(o => o.value === val)
				if (!opt) return null
				return (
					<button
						key={i}
						type="button"
						onClick={() => onRemoveFilterOption && onRemoveFilterOption(field, val)}
						style={{
							border: '1px solid #3A86FF',
							borderRadius: 12,
							padding: '6px 14px',
							background: '#E3F0FF',
							color: '#3A86FF',
							fontWeight: 600,
							fontSize: 14,
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							gap: 6
						}}
						title={`Remove ${opt.label}`}
					>
						{opt.label}
						<DeleteIcon fontSize="small" style={{ marginLeft: 4 }} />
					</button>
				)
			})}
		</div>
	</div>
)

/**
 * Panel header
 * @param {*} props
 */
const PanelHeader = (props) => {
	const { title } = props
	const { onClose } = props
	const classes = panelLateralServicesStyles()

	return (
		<div className={classes.panelHeader}>
			<div className={classes.containerHeader}>
				<div className={classes.containerIcon}>
					<Fab size='medium' className={classes.faultWarrantyIconSelected} disabled={true}>
						<BarChartIcon className={classes.faultWarrantyIcon} style={{ color: '#fff' }} />
					</Fab>
				</div>
				<div className={classes.containerText}>
					<Typography gutterBottom variant='subtitle1' className={classes.title}>
						{title}
					</Typography>
				</div>
			</div>
			<div className={classes.grow} />
			<Fab className={classes.buttonClose} onClick={onClose}>
				<DeleteIcon />
			</Fab>
		</div>
	)
}